import React from "react";
export const FontAwesomeIconCtx = React.createContext(null);
export const useFontAwesomeIcon = () => {
    const C = React.useContext(FontAwesomeIconCtx);
    if (C == null) {
        throw new Error("FontAwesomeIconCtx is null");
    }
    return C;
};
